import { render } from "./ModalsItemView.vue?vue&type=template&id=326ed3cf&scoped=true"
import script from "./ModalsItemView.vue?vue&type=script&lang=js"
export * from "./ModalsItemView.vue?vue&type=script&lang=js"

import "./ModalsItemView.vue?vue&type=style&index=0&id=326ed3cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326ed3cf"]])

export default __exports__